import { Button } from '@/components/UI/Common/Admin/Button';
import { ImageUpload } from '@/components/UI/Common/Admin/ImageUpload';
import { Input } from '@/components/UI/Common/Admin/Input';
import { chatTemplateScheme } from '@/config/validations';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, Controller } from 'react-hook-form';
import z from 'zod';

export type FormData = z.infer<typeof chatTemplateScheme>;

export const Form = ({
  formData,
  onSubmit,
  onDelete,
}: {
  onSubmit: (data: FormData) => void;
  formData?: Partial<FormData>;
  onDelete?: VoidFunction;
}) => {
  const initialFormState = formData
    ? formData
    : ({
        systemName: '',
        title: '',
        sort: 1,
        avatar: {
          url: '',
          rawFile: null,
        },
      } as Partial<FormData>);

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    control,
  } = useForm<FormData>({
    resolver: zodResolver(chatTemplateScheme),
    defaultValues: initialFormState,
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
      <Input
        {...register('systemName')}
        error={errors?.systemName?.message}
        label="Системное имя"
        required
      />
      <Input {...register('title')} error={errors?.title?.message} label="Название" required />
      <Input
        {...register('sort', { valueAsNumber: true })}
        error={errors?.sort?.message}
        label="Порядок"
        required
        type="number"
        min={0}
      />

      <Controller
        name="avatar"
        control={control}
        render={({ field, fieldState }) => (
          <ImageUpload
            error={fieldState.error?.message}
            value={field.value?.url}
            onImageChange={(file) => field.onChange({ url: '', rawFile: file })}
          />
        )}
      />

      <div className="flex justify-end gap-4">
        {onDelete && (
          <Button variant="danger" onClick={onDelete} type="button">
            Удалить
          </Button>
        )}
        <Button variant="secondary" disabled={!isDirty} onClick={() => reset()} type="button">
          Сбросить
        </Button>
        <Button disabled={!isValid || !isDirty} type="submit">
          Сохранить
        </Button>
      </div>
    </form>
  );
};
